import { isMobile } from '../../../../core/helpers/isMobile';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { popupStore } from '../../../../store/popupStore';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { checkHashStore } from '../../../../store/checkHashStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { userInfoStore } from '../../../../store/userInfoStore';
import { isPG, isTopC } from '../../../../core/helpers/skinHelper';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';

export const BACCARAT_GAME_ID = 45;

export const CARDS_MAX_COUNT = new Array(3).fill(null).map((el, index) => index + 1);

export const BACCARAT_CHIPS_COLOR = [
  'skyblue',
  'pink_1k',
  'purple_1k',
  'darkblue_1k',
  'lightblue_1k',
  'orange_1k',
  'green_1k',
  'red_1k',
  'purple1_10k',
  'yellow_100k',
];

export const BACCARAT_BET_TYPES = {
  PLAYER: 0,
  BANKER: 1,
  TIE: 2,
  PLAYER_PAIR: 3,
  BANKER_PAIR: 4,
};

export const BACCARAT_BET_TYPES_NAMES = {
  0: 'PLAYER',
  1: 'BANKER',
  2: 'TIE',
  3: 'PLAYER_PAIR',
  4: 'BANKER_PAIR',
};

export const SPIN_WIN_TYPE = {
  Banker: 0,
  Player: 1,
  Tie: 2,
};

export const PAIR_SPIN_WIN_TYPE = {
  PlayerPair: 2,
  BankerPair: 1,
  Both: 3,
};

export const BANKER_CARD = 1;
export const PLAYER_CARD = 2;

export const ODD_BY_BET_TYPE = [
  {
    name: TranslationKeys.PPair,
    type: BACCARAT_BET_TYPES.PLAYER_PAIR,
    odd: '12.00',
    sideBetWinType: PAIR_SPIN_WIN_TYPE.PlayerPair,
    both: PAIR_SPIN_WIN_TYPE.Both,
  },
  {
    name: TranslationKeys.Player,
    type: BACCARAT_BET_TYPES.PLAYER,
    odd: '2.00',
    winBetType: SPIN_WIN_TYPE.Player,
  },
  {
    name: TranslationKeys.Tie,
    type: BACCARAT_BET_TYPES.TIE,
    odd: '9.00',
    winBetType: SPIN_WIN_TYPE.Tie,
  },
  {
    name: TranslationKeys.Banker,
    type: BACCARAT_BET_TYPES.BANKER,
    odd: '1.95',
    winBetType: SPIN_WIN_TYPE.Banker,
  },
  {
    name: TranslationKeys.BPair,
    type: BACCARAT_BET_TYPES.BANKER_PAIR,
    odd: '12.00',
    sideBetWinType: PAIR_SPIN_WIN_TYPE.BankerPair,
    both: PAIR_SPIN_WIN_TYPE.Both,
  },
];

export const BaccaratLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const BaccaratBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'id',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({ name: PopupTypes.Fairness, spinInfo });
          checkHashStore.setSpinInfo({
            salt: spinInfo.salt,
            key: spinInfo.key,
            hash: spinInfo.hash,
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Market,
    dataKey: 'default',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo, t) => {
      return (
        <span className='cpt-table-text'>
          {spinInfo.markets.length === 1 ? (
            t(BACCARAT_BET_TYPES_NAMES[spinInfo.markets[0]?.type])
          ) : (
            <span
              onClick={(e) => {
                e.stopPropagation();
                popupStore.open({ name: PopupTypes.Fairness, spinInfo });
                checkHashStore.setSpinInfo({
                  salt: spinInfo.salt,
                  key: spinInfo.key,
                  hash: spinInfo.hash,
                });
              }}
              className='multi-selection'
            >
              {t(TranslationKeys.MultiSelection)}
            </span>
          )}
        </span>
      );
    },
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const BACCARAT_RULES_KEYS = new Array(isPG() ? 47 : 24)
  .fill(null)
  .map((item, index) => index + 1);
export const BACCARAT_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
